var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.26 4.44a1 1 0 0 1 0 1.414l-7.072 7.07a1 1 0 0 1-1.414 0l-.011-.012-3.525-3.523a1 1 0 0 1 1.415-1.414l2.829 2.828 6.363-6.364a1 1 0 0 1 1.414 0Z",
    fill: "currentcolor",
    fillRule: "nonzero"
  })));
};

export default SvgCheckmark;